// Kurdish labels for the enum values the backend stores in English.
//
// Single source of truth: the audit log renders these fields inside a diff,
// while the orders screens render them directly. Both import from here so a
// status or unit is never spelled two different ways.

export const STATUS_LABELS = {
    pending: "چاوەڕوان",
    confirmed: "پەسەندکراو",
    fulfilled: "گەیەنراو",
    rejected: "ڕەتکراوە",
    cancelled: "هەڵوەشاوە",
};

// OrderProduct.md §4.3: items[].unit is one of carton | darzan | dana.
export const UNIT_LABELS = {
    carton: "کارتۆن",
    darzan: "دەرزەن",
    dana: "دانە",
};

export const CURRENCY_LABELS = {
    USD: "دۆلار",
    IQD: "دینار",
};

export const ROLE_LABELS = {
    admin: "بەڕێوەبەر",
    user: "بەکارهێنەر",
    ipad: "ئایپاد",
};

export const statusLabel = (value) => STATUS_LABELS[value] || value || "-";
export const unitLabel = (value) => UNIT_LABELS[value] || value || "-";
export const currencyLabel = (value) => CURRENCY_LABELS[value] || value || "";
export const roleLabel = (value) => ROLE_LABELS[value] || value || "-";
